import { render, staticRenderFns } from "./ResumeRequests.vue?vue&type=template&id=f21d907c"
import script from "./ResumeRequests.vue?vue&type=script&lang=js"
export * from "./ResumeRequests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports